var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarJobManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26.78 -208.3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M26.78,211.3v12h12v-15h-9l-3,3ZM35.78,216.3h-2.5v2.5h-1v-2.5h-2.5v-1h2.5v-2.5h1v2.5h2.5v1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarJobManagement);
export default __webpack_public_path__ + "static/media/sidebar_job_management.5c0c89b7d32207b182ee95a490350b0a.svg";
export { ForwardRef as ReactComponent };